// import {
//   FiMessageSquare,
//   FiShield,
//   FiTrendingUp,
//   FiArrowRight,
//   FiUsers,
//   FiAward,
//   FiGlobe,
// } from "react-icons/fi";
// import { Link } from "react-router-dom";
// import { AiOutlineArrowRight } from "react-icons/ai";
// export default function AboutSection() {
//   const stats = [
//     { value: "50K+", label: "Active Traders", icon: <FiUsers /> },
//     { value: "98%", label: "Success Rate", icon: <FiAward /> },
//     { value: "24/7", label: "Support", icon: <FiGlobe /> },
//   ];

//   return (
//     <div className="relative pt-6 pb-16 overflow-hidden bg-gray">
//       <div className="relative px-4 mx-auto lg:px-0 max-w-7xl">
//         <div className="grid items-center grid-cols-1 gap-16 lg:grid-cols-2">
//           <div className="relative">
//             <div className="relative p-1 ">
//               <img
//                 src="https://img.freepik.com/free-photo/person-using-ar-technology-perform-their-occupation_23-2151137537.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777&semt=ais_hybrid"
//                 alt="MetaMask"
//                 className="relative object-cover w-full h-auto shadow-2xl rounded-xl"
//               />
//             </div>
//           </div>
//           <div className="space-y-10">
//             <div className="space-y-2">
//               <div className="inline-flex items-center px-8 py-1 text-sm text-indigo-600 border rounded-full bg-indigo-500/10 border-indigo-500/20">
//                 Web3
//               </div>
//               <div>
//                 <h2 className="mb-3 text-4xl font-semibold text-green-500">
//                   <span className="text-transparent text-yellow-400 bg-clip-text ">
//                   How It 
//                   </span>{" "}
//                   Works
//                 </h2>
//                 <p className="text-base leading-relaxed text-justify text-gray-600">
//                 Trading with Earn 4U is simple and hassle-free. Follow these easy steps to begin your journey toward financial growth.

//                 </p>
//               </div>
//               <div className="">
                
//                 <ul className="pl-5 text-base text-gray-600">
//                   <li className="list-disc">
//                     <span>Sign Up & Verify – Create your free account and complete a quick verification.</span>
//                   </li>
//                   <li className="list-disc">
//                     <span>2️ Fund Your Wallet – Deposit funds securely to start trading.</span>
//                   </li>
//                   <li className="list-disc">
//                     <span>Trade & Earn – Choose your market, place trades, and withdraw profits anytime.</span>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             <Link to="/registration">
//               <button className="relative mt-4 overflow-hidden font-semibold transition-all duration-300 rounded-lg group ">
//                 <button className="flex items-center gap-2 p-1 py-1 text-white bg-yellow-400 rounded-full ">
//                   <span className="px-4 py-2 bg-green-800 rounded-full">
//                     {" "}
//                     Conncet
//                   </span>
//                   <div className="p-3 bg-white rounded-full">
//                     <AiOutlineArrowRight className="w-4 h-4 text-green-600" />
//                   </div>
//                 </button>
//               </button>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useRef } from "react";

export const AboutSection = () => {
  const shapeRef = useRef(null);

  useEffect(() => {
    const rotateShape = () => {
      if (shapeRef.current) {
        // Increased rotation speed by multiplying the time factor by 8
        shapeRef.current.style.transform = `rotate(${(Date.now() / 1000 * 8) % 360}deg)`;
        requestAnimationFrame(rotateShape);
      }
    };
    
    const animationId = requestAnimationFrame(rotateShape);
    
    return () => {
      cancelAnimationFrame(animationId);
    };
  }, []);
  return (
    <>

    <div className=" py-16 px-4 sm:px-6 xl:px-12 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#263283] to-[#ed2924] opacity-80"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-10 items-center">
          {/* Image container with proper responsive positioning */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            {/* Fixed height container to maintain proper spacing */}
            <div className="relative h-96 w-full lg:h-[450px] xl:h-[500px]">
              {/* Rotating shape image with responsive positioning */}
              <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                <img 
                  ref={shapeRef}
                  src="https://thepixelcurve.com/html/techwix/techwix/assets/images/shape/about-shape1.png" 
                  alt="Decorative shape" 
                  className="absolute z-10 w-64 sm:w-80 lg:w-96 xl:w-[500px]"
                />
                
                {/* Main profile image - centered and responsive */}
                <div className="absolute z-30 w-40 h-40 sm:w-52 sm:h-52 md:w-64 md:h-64 lg:w-60 lg:h-60 xl:w-72 xl:h-72 rounded-full overflow-hidden shadow-2xl border-4 border-blue-400">
                  <img 
                    src="https://thepixelcurve.com/html/techwix/techwix/assets/images/about-img3.jpg" 
                    alt="About us"  
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              
              {/* Decorative elements with responsive positioning */}
              <div className="absolute bottom-4 right-4 lg:bottom-8 lg:right-8 bg-blue-500 w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 rounded-full opacity-20"></div>
              <div className="absolute bottom-20 left-4 lg:bottom-32 lg:left-8 bg-green-500 w-12 h-12 sm:w-16 sm:h-16 rounded-full opacity-20"></div>
            </div>
          </div>

          <div className="relative text-white space-y-6 lg:space-y-8">
            <div className="inline-block mb-2">
              <span className="bg-blue-500 px-4 py-1 rounded-full text-sm font-semibold">About Us</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            Forex Made Simple for the Future

            </h2>
            
            <p className="text-lg md:text-xl leading-relaxed text-gray-300">
            Gold Fox Market (GFM) is a Forex trading platform built for traders who want simplicity, speed, and smart automation. We believe that trading shouldn’t be complicated. That’s why we offer powerful trading bots and easy tools to help everyone—from beginners to experts—succeed in the Forex market.
            </p>
            <p className="text-lg mt-2 md:text-xl leading-relaxed text-gray-300">
            
Our mission is to make Forex trading more accessible, more efficient, and more profitable for all. With a focus on innovation and security, we aim to lead the future of automated trading. Join a growing community of traders who trust GFM for their trading journey.

            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-3">
                <div className="bg-blue-500 p-2 rounded-full">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="font-medium">Advanced Forex Trading Bots</span>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="bg-green-500 p-2 rounded-full">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="font-medium">Beginner-Friendly Platform</span>
              </div>
            </div>
            
            <div className="pt-4">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 sm:px-8 sm:py-4 rounded-full text-lg sm:text-xl font-semibold transition duration-300 shadow-xl flex items-center gap-2">
                Explore More
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
 
    
    </>
  )
}

